import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button } from '@mui/material'
import T from 'T'

const DeactivateAllConfirmation = ({ onConfirm, onCancel, deactivatableLocationsCount }) => {
  return (
    <Box display="flex" justifyContent="space-between" gap={1} px={2} pb={2}>
      <Button variant="text" size="small" onClick={onCancel}>
        {T.CANCEL}
      </Button>
      <Button
        variant="contained"
        size="small"
        color="warning"
        onClick={onConfirm}
        disabled={deactivatableLocationsCount === 0}
        sx={{
          backgroundColor: 'warning.light',
          color: 'warning.contrastText',
          '&:hover': {
            backgroundColor: 'warning.dark',
          },
        }}
      >
        {T.DEACTIVATE}
      </Button>
    </Box>
  )
}

DeactivateAllConfirmation.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  deactivatableLocationsCount: PropTypes.number.isRequired,
}

export default DeactivateAllConfirmation
